import { Tooltip } from "antd"
import { cn } from "lib/utils"
import React from "react"
import { twMerge } from "tailwind-merge"

interface TabProps {
  tabs: { label: React.ReactNode; value: string; tooltip?: string }[]
  selectedTab: string
  setSelectedTab: any
  size?: "sm" | "lg"
  className?: string
}

function Tabs(props: TabProps) {
  return (
    <div
      className={twMerge(
        "bg-selected aldeia:bg-ground rounded-full inline-flex items-center p-1",
        props.size === "sm" && "p-0.5",
        props.className,
      )}
    >
      {props.tabs?.map((tab, index) => {
        return (
          <Tooltip key={tab?.value} title={tab?.tooltip} mouseEnterDelay={0}>
            <a
              className={twMerge(
                `px-4 py-1 cursor-pointer rounded-full flex items-center justify-center text-sm hover:bg-base-400 min-w-0 truncate ${
                  props.selectedTab === tab?.value ? "!bg-base-100 shadow font-medium" : ""
                }`,
                props.size === "sm" && "px-3 py-1",
              )}
              onClick={() => props.setSelectedTab(tab?.value)}
            >
              {/* <span className={twMerge(props.selectedTab === tab?.value ? "bg-primary !text-white shadow" : "")}>{tab?.label}</span> */}
              <span
                className={cn(
                  "min-w-0 truncate",
                  props.selectedTab === tab?.value ? "!text-content-100" : "dark:text-content-200 dark:hover:text-content-100",
                )}
              >
                {tab?.label}
              </span>
            </a>
          </Tooltip>
        )
      })}
    </div>
  )
}

export default Tabs
